import { BaseModel } from "@/models/base.model"
import { type IAvailabilityBlock } from "@/interfaces/api/availability-block.interface.ts"
import { type AvailabilityTypes } from "@/enums/models/availability-types.ts"
import { type Moment } from "moment"
import { type IAvailabilityReason } from "@/interfaces/api/availability-reason.interface.ts"

export class AvailabilityBlock extends BaseModel implements IAvailabilityBlock {
  public static className = "AvailabilityBlock" // Used for socket communication.
  public static verboseName = "beschikbaarheidsblok"

  availabilityBucket: string
  availabilityType: AvailabilityTypes
  reason: IAvailabilityReason | null
  timeStart: Moment | null
  timeEnd: Moment | null
  description?: string | null

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(availabilityBlock: IAvailabilityBlock, managed = false) {
    super(availabilityBlock)

    this.availabilityBucket = availabilityBlock.availabilityBucket
    this.availabilityType = availabilityBlock.availabilityType
    this.reason = availabilityBlock.reason
    this.timeStart = availabilityBlock.timeStart
    this.timeEnd = availabilityBlock.timeEnd
    this.description = availabilityBlock.description
  }
}
